import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputLabel,
  Radio
} from '@material-ui/core'
import { uniqueId } from 'lodash'
import React from 'react'
import { IPointrThemedChoiceGroup } from './Interfaces'
import usePointrThemedChoiceGroup from './Styles'

const PointrThemedChoiceGroup: React.FC<IPointrThemedChoiceGroup> = ({
  label,
  options,
  selected,
  error,
  onChange,
  helperText,
  variant,
  classes: stylesOverrides
}) => {
  const inputId = `pointr-themed-form-item-${uniqueId()}`
  const classes = usePointrThemedChoiceGroup({})

  const InputComponent = variant === 'checkbox' ? Checkbox : Radio

  return (
    <div className={classes.formRow}>
      <FormControl className={classes.formControl} error={error}>
        {!!label && (
          <InputLabel id={`${inputId}-label`} className={stylesOverrides?.label} shrink htmlFor={inputId}>
            {label}
          </InputLabel>
        )}
        <FormGroup>
          {options.map(option => (
            <FormControlLabel
              key={option.id}
              control={
                <InputComponent
                  checked={selected && selected.includes(option.id)}
                  value={option.id}
                  onChange={onChange}
                  name={option.text}
                  color={'default'}
                />
              }
              label={option.text}
            />
          ))}
        </FormGroup>
        {helperText && <FormHelperText id={`${inputId}-helper-label`}>{helperText}</FormHelperText>}
      </FormControl>
    </div>
  )
}

PointrThemedChoiceGroup.defaultProps = {
  error: false,
  helperText: null,
  options: [],
  selected: [],
  variant: 'checkbox'
}

export default PointrThemedChoiceGroup
